import React, { useState, useRef, useEffect } from "react";
import "styles/css/util/helpers/ScrollArrow.css";


const defaultLinearGradientColor = {
	red: 255,
	green: 255,
	blue: 255
}


function ScrollArrow({
	children,
	mainContainerStyle = {},
	itemsContainerStyle = {},
	leftButtonStyle = {},
	rightButtonStyle = {},
	scrollAmount = 100,
	backgroundFadeColor = defaultLinearGradientColor,
	infiniteScroll = false,
	arrowsWidth = "40px",
	align = "center",
	reserveArrowsSpace = false
}) {

	const [scrollPosition, setScrollPosition] = useState(0);
	const [isContentScrollable, setIsContentScrollable] = useState(false);
	const [showLeftArrow, setShowLeftArrow] = useState(false);
	const [showRightArrow, setShowRightArrow] = useState(false);
	const scrollTabsContainerRef = useRef();

	// Read from the DOM: the reserved arrow space changes the visible width after the first measure
	const getMaxScroll = () =>
		scrollTabsContainerRef.current.scrollWidth - scrollTabsContainerRef.current.clientWidth;

	const handleHorizontalScroll = (scrollAmount) => {

		const itemsContainerMaxScroll = getMaxScroll();
		let newScrollPosition = scrollPosition + scrollAmount;
		let remainingScroll = itemsContainerMaxScroll;

		if (infiniteScroll) {
			if (newScrollPosition < 0 && scrollPosition == 0)
				newScrollPosition = itemsContainerMaxScroll;

			if (newScrollPosition > itemsContainerMaxScroll && scrollPosition == itemsContainerMaxScroll)
				newScrollPosition = 0;
		}

		// Check for right and left scroll, respectively
		if (scrollAmount < 0) remainingScroll = newScrollPosition;
		if (scrollAmount > 0) remainingScroll = itemsContainerMaxScroll - newScrollPosition;

		if (remainingScroll <= itemsContainerMaxScroll * 0.2) {
			// Check for right and left scroll, respectively
			if (scrollAmount < 0) newScrollPosition = 0;
			if (scrollAmount > 0) newScrollPosition = itemsContainerMaxScroll;
		}

		if (newScrollPosition < 0) newScrollPosition = 0;
		if (newScrollPosition > itemsContainerMaxScroll) newScrollPosition = itemsContainerMaxScroll;

		setScrollPosition(newScrollPosition);
		scrollTabsContainerRef.current.scrollLeft = newScrollPosition;
	}

	const onClickScrollLeft = () => {
		handleHorizontalScroll(-scrollAmount);
	};

	const onClickScrollRight = () => {
		handleHorizontalScroll(scrollAmount);
	};

	useEffect(() => {
		const scrollContainer = scrollTabsContainerRef.current;
		if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
			setShowLeftArrow(false);
			setShowRightArrow(true);
			setIsContentScrollable(true);
		} else {
			setShowLeftArrow(false);
			setShowRightArrow(false);
			setIsContentScrollable(false);
		}
	}, [children, scrollTabsContainerRef.current?.scrollWidth])


	useEffect(() => {
		if (isContentScrollable) {
			const itemsContainerMaxScroll = getMaxScroll();
			if (scrollPosition <= 0) {
				setShowLeftArrow(false);
				setShowRightArrow(true);
			} else if (scrollPosition >= itemsContainerMaxScroll) {
				setShowLeftArrow(true);
				setShowRightArrow(false);
			} else {
				setShowLeftArrow(true);
				setShowRightArrow(true);
			}
		}
	}, [children, scrollPosition, isContentScrollable])

	const rgbGradientColor = `${backgroundFadeColor.red}, ${backgroundFadeColor.green}, ${backgroundFadeColor.blue}`;

	return (
		<div id="scroll-arrow-main-container" style={{
			overflow: 'hidden',
			...mainContainerStyle
		}}>
			<div
				className="scroll-btn left-btn"
				style={{
					display: "flex",
					justifyContent: "center",
					width: arrowsWidth,
					visibility: (showLeftArrow || infiniteScroll) ? "visible" : "hidden",
					background: `
						linear-gradient(
							to left,
							rgba(${rgbGradientColor}, 0) 0%,
							rgba(${rgbGradientColor}, 0.1) 50%,
							rgba(${rgbGradientColor}, 0.25) 100%
						)`
				}}
				onClick={onClickScrollLeft}
			>
				<div className="d-flex justify-content-center align-items-center" style={leftButtonStyle}>
					&#10094;
				</div>
			</div>
			<div className={`w-100 scroll-container ${!isContentScrollable ? "justify-content-" + align : ""}`}
				style={{
					...(reserveArrowsSpace && isContentScrollable && { margin: `0 ${arrowsWidth}` }),
					...itemsContainerStyle
				}}
				ref={scrollTabsContainerRef}
			>
				{children}
			</div>
			<div
				className="scroll-btn right-btn"
				style={{
					display: "flex",
					justifyContent: "center",
					width: arrowsWidth,
					visibility: (showRightArrow || infiniteScroll) ? "visible" : "hidden",
					background: `
						linear-gradient(
							to right, 
							rgba(${rgbGradientColor}, 0) 0%, 
							rgba(${rgbGradientColor}, 0.1) 50%, 
							rgba(${rgbGradientColor}, 0.25) 100%)`
				}}
				onClick={onClickScrollRight}
			>
				<div className="d-flex justify-content-center align-items-center" style={rightButtonStyle}>
					&#10095;
				</div>
			</div>
		</div>
	)

}

export default ScrollArrow;